module.exports = {"pricing Table":[{"text":"Detailed Research Reports","24 Months":true,"48 Months":true},{"text":"Regular Stock Updates","24 Months":true,"48 Months":true},{"text":"Clear buy & Sell Instructions","24 Months":true,"48 Months":true},{"text":"Personalised Strategy Call","24 Months":true,"48 Months":true},{"text":"Capital allocation strategy","24 Months":true,"48 Months":true},{"text":"Past Portfolio Guidance (optional)","24 Months":false,"48 Months":true},{"text":"Complete Beginner's Guide","24 Months":true,"48 Months":true},{"text":"Investing Articles","24 Months":true,"48 Months":true}]}


//////////////////
// WEBPACK FOOTER
// ./src/util/pricing.json
// module id = lmRY
// module chunks = 1